export class Model_Crm_Employees
{

     public  EmployeeId :number;
     public  EmployeeCode :string;
     public  FullName : string;
     public  UserId : number; 
       
    
}  